import config from 'config';

export const getIsOnProductionEnvironment = () => config.environment === 'production';
